<template>
	<v-main>
		<div
			ref="topPage"
			class="head-banner pb-12 pb-md-0"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<template v-if="$route.params.category === 'property-review'">
									<v-btn
										color="red"
										class="px-0"
										height="auto"
										exact
										x-large
										text
										:to="{name: 'blog-review'}"
									>
										บทความรีวิว
									</v-btn>
								</template>
								<template v-else-if="$route.params.category === 'tips'">
									<v-btn
										color="red"
										class="px-0"
										height="auto"
										exact
										x-large
										text
										:to="{name: 'blog-tips'}"
									>
										บทความสาระน่ารู้
									</v-btn>
								</template>
								<template v-else-if="$route.params.category === 'home-knowledge'">
									<v-btn
										color="red"
										class="px-0"
										height="auto"
										exact
										x-large
										text
										:to="{name: 'blog-home-knowledge'}"
									>
										บทความความรู้เรื่องบ้าน
									</v-btn>
								</template>

								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span>{{ title || '' }}</span>
							</div>
							<div class="search-filter white--text">
								<span>บทความ</span>

								<div class="pl-3 pr-5">
									<template v-if="$route.params.category === 'property-review'">
										บทความรีวิว
									</template>
									<template v-else-if="$route.params.category === 'tips'">
										บทความสาระน่ารู้
									</template>
									<template v-else-if="$route.params.category === 'home-knowledge'">
										บทความความรู้เรื่องบ้าน
									</template>
								</div>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div style="height: 300px;">
				<z-img
					:storage="bannerImg"
					max-width="100%"
					height="300"
				/>
			</div>
		</div>

		<div class="pb-6">
			<v-container>
				<v-row>
					<v-col
						xl="8"
						offset-xl="2"
					>
						<template v-if="contents">
							<v-row class="article-header">
								<v-col
									cols="12"
									md="9"
								>
									<h1>{{ title }}</h1>
									<div class="my-3 d-flex align-center">
										<v-icon
											class="mr-2"
											color="rgb(237,28,36"
										>
											mdi-clock
										</v-icon>
										{{ date }}
									</div>
								</v-col>
								<v-col
									cols="12"
									md="3"
									class="align-self-end pb-8 pr-0"
								>
									<v-btn
										:href="`https://www.facebook.com/sharer/sharer.php?u=https://tb.co.th${$route.path}`"
										:title="`แชร์ ${title} บนเฟสบุ๊ค`"
										target="_blank"
										small
										fab
									>
										<img src="/images/2.0/icon/facebook-bk.png">
									</v-btn>
									<v-btn
										:href="`https://social-plugins.line.me/lineit/share?url=https://tb.co.th${$route.path}`"
										:title="`แชร์ ${title} ในไลน์`"
										target="_blank"
										class="ml-1"
										fab
									>
										<img src="/images/2.0/icon/line-bk.png">
									</v-btn>
									<v-btn
										:href="`https://twitter.com/intent/tweet?text=https://tb.co.th${$route.path}`"
										:title="`แชร์ ${title} บน Twitter`"
										target="_blank"
										class="ml-1"
										fab
									>
										<img src="/images/2.0/icon/twitter-bk.png">
									</v-btn>
									<v-btn
										class="ml-1"
										fab
										@click="copyText(`https://tb.co.th${$route.path}`)"
									>
										<img src="/images/2.0/icon/link-red.png">
									</v-btn>
								</v-col>
								<v-divider />
								<v-col
									cols="12"
									md="9"
								>
									<!-- eslint-disable-next-line vue/no-v-html -->
									<span v-html="contents" />
								</v-col>
								<v-col
									cols="3"
									class="next-article pt-11 d-none d-md-block"
								>
									<template v-if="next && next.length > 0">
										รีวิว<span class="red--text">ถัดไป</span>
										<div
											v-for="(article, i) in next"
											:key="`next-${i}`"
											class="my-5"
										>
											<articleReviewItem
												:article="article"
												elevation="10"
											/>
										</div>
									</template>
								</v-col>
							</v-row>
						</template>
						<div v-else>
							<h1 class="text-center py-12 my-12">
								ไม่พบบทความ
							</h1>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<v-snackbar
			v-model="snackbar"
			top
			right
			:timeout="6000"
		>
			{{ snackbarText }}
			<v-btn
				color="blue"
				text
				@click="snackbar = false"
			>
				Close
			</v-btn>
		</v-snackbar>

		<input
			ref="dummyInput"
			type="text"
			class="dummy-input"
			style="border: none !important;"
		>
	</v-main>
</template>

<script>
// const doc = 'blog_review'

import { mapGetters } from 'vuex'

import articleReviewItem from '~/components/2.0/article-review-item'

export default {
	// scrollToTop: true,
	name: 'ARTICLE',
	layout: 'default_2',

	components: {
		articleReviewItem,
	},

	async asyncData(context) {
		let { category, slug } = context.route.params || {}
		let doc = null
		if (category && slug) {
			let article = await context.app.$fireStore.collection('articles')
				.where('category', '==', category)
				.where('slug', '==', slug)
				.limit(1)
				.get()

			// if (article.size === 0) {
			// 	category = 'home-knowledge'
			// 	article = await context.app.$fireStore.collection('articles')
			// 		.where('category', '==', category)
			// 		.where('slug', '==', slug)
			// 		.limit(1)
			// 		.get()
			// }


			if (article.size > 0) {
				let articleData = article.docs[0].data()
				if (articleData.published_at) {
					let { contents, created_at, title, description, featured, slug } = articleData
					doc = slug

					let next = await context.app.$fireStore.collection('articles')
						.where('category', '==', category)
						.where('published', '==', true)
						.orderBy('created_at', 'desc')
						.startAfter(articleData.created_at)
						.limit(3)
						.get()

					await context.store.dispatch('page/initial', {
						doc,
						title,
						description,
						fullPath: context.route.fullPath,
						image: featured
					})

					contents = contents.replace(/<h1>[\S\s]*<\/h1>/m, '')

					return {
						category,
						contents,
						date: !created_at ? '' : new Intl.DateTimeFormat('th-TH', { dateStyle: 'long' }).format(created_at.seconds * 1000),
						doc: slug,
						next: next.docs.map(doc => doc.data()),
						title,
					}
				}
			}
		}

		doc = '404'
		await context.store.dispatch('page/initial', {
			doc,
			title: 'ไม่พบบทความ'
		})

		return {
			doc,
			contents: null
		}
	},

	data:() => ({
		keepAliveActivated: false,
		loading: false,
		snackbar: false,
		snackbarText: '',
		page: 1,
		maxHeight: '100%'
	}),

	computed: {
		...mapGetters({
			head: 'page/head',
		}),

		list () {
			return this.articleList.slice((this.page - 1) * this.perPage, this.page * this.perPage)
		},

		totalPage () {
			return Math.ceil(this.total / this.perPage)
		},

		totalItem () {
			return new Intl.NumberFormat('th-TH', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(this.total)
		},

		bannerImg () {
			return '/images/2.0/article-banner.jpg'
		},
	},

	watch: {

	},

	activated () {
		if (window.windowNavigate) {
			window.windowNavigate = false
		} else if (this.keepAliveActivated) {
			// this.search()
		}
	},

	created() {

	},

	mounted() {

	},

	methods: {
		copyText(text) {
			const ref = this.$refs.dummyInput
			ref.value = text
			ref.focus()
			ref.select()

			try {
				document.execCommand('copy')
				this.snackbarText = 'คัดลอกแล้ว'
			} catch (err) {
				console.log('Oops, unable to copy')
				this.snackbarText = 'ไม่สามารถคัดลอกได้'
			} finally {
				ref.blur()
				ref.value = ''

				this.snackbar = true
			}
		},
	},

	head() {
		return this.head(this.doc)
	}
}
</script>

<style lang="scss" scoped>
.head-banner {
	position: relative;

	.search-filter {
		position: absolute;
		top: 155px;
		z-index: 2;

		span {
			font-size: 3em;
		}
		div {
			border-left: solid 4px #c20000;
			font-size: 2em;
		}
	}
}
::v-deep {
	.article-header {
		.v-btn {
			width: 47px;
			height: 47px;

			img {
				width: 47px;
			}
		}

		hr {
			min-width: 200vw;
			margin-left: -100%;
			// border-bottom: solid 2px #eee;
		}
	}
	h2 {
		color: rgb(237,28,36);
	}

	a {
		color: rgb(237,28,36);
		text-decoration: none;
	}

	figure.image {
		text-align: center;
	}
	img {
		max-width: 100%;
	}

	figure.table table {
		background-color: #eee;
    border-top: solid 5px rgb(237,28,36);
    padding: 0 30px;
		border-spacing: 0;

		tr {

			& > td {
				padding: 8px 10px;
				vertical-align: top;
				border-bottom: solid 1px #aaa;
				overflow-wrap: anywhere;
			}
			&:last-child > td {
				border: none;
				padding-bottom: 30px;
			}
		}
		tr > td:first-child {
			white-space: nowrap;
		}
	}
}
.next-article {
	font-size: 2em;
}
.dummy-input {
	position: fixed;
	left: -100%;
	bottom: -100%;
}
</style>
